import { render, staticRenderFns } from "./profile-foreigner.vue?vue&type=template&id=0558c075&scoped=true"
import script from "./profile-foreigner.vue?vue&type=script&lang=js"
export * from "./profile-foreigner.vue?vue&type=script&lang=js"
import style0 from "./profile-foreigner.vue?vue&type=style&index=0&id=0558c075&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558c075",
  null
  
)

export default component.exports